import { AppointmentType } from "types";

const TYPES: Record<string, AppointmentType> = {
  instant: "now",
  appointment: "later",
};

const TYPES_REVERSED: Record<AppointmentType, string> = {
  now: "instant",
  later: "appointment",
};

const transformAppointmentType = (type: string) => {
  return TYPES[type];
};

const untransformAppointmentType = (type: AppointmentType) => {
  return TYPES_REVERSED[type];
};

export { transformAppointmentType, untransformAppointmentType };
